import { createContext, PropsWithChildren, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmModal } from "components/shared";
import {
  TConfirmContextValue,
  TConfirmModalOptions,
} from "./ConfirmContext.types";

export const ConfirmContext = createContext<TConfirmContextValue | undefined>(
  undefined,
);

export const ConfirmProvider = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation("common");
  const [modal, setModal] = useState(<></>);

  const attemptConfirm = useCallback(
    async (customOptions: TConfirmModalOptions): Promise<boolean> => {
      const {
        confirmButtonText,
        cancelButtonText,
        title,
        confirmColor,
        content,
      } = customOptions;

      const isConfirmed = await new Promise<boolean>((resolve) => {
        setModal(
          <ConfirmModal
            open
            onConclude={resolve}
            title={title || t("pleaseConfirm")}
            confirmButtonText={confirmButtonText || t("button.confirm")}
            cancelButtonText={cancelButtonText || t("button.cancel")}
            confirmColor={confirmColor}
          >
            {content}
          </ConfirmModal>,
        );
      });

      setModal(<></>);

      return isConfirmed;
    },
    [t],
  );

  return (
    <ConfirmContext.Provider value={{ attemptConfirm }}>
      {children}
      {modal}
    </ConfirmContext.Provider>
  );
};
